export const SETUP_EVENT = {
  INTEGRATION_SUCCESS: `integrations xero connect success`,
  INTEGRATION_FAIL: `integrations xero connect fail`,
};
